import { render, staticRenderFns } from "./main-window.vue?vue&type=template&id=981f90ec&"
import script from "./main-window.vue?vue&type=script&lang=js&"
export * from "./main-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports